import * as t from 'io-ts';

export const preAlertVessel = t.string;

export const VESSEL_NAMES = [
  'A BOTE',
  'A FUKU',
  'A KEIGA',
  'A KIBO',
  'A KOU',
  'A MAKOTO',
  'A MIZUHO',
  'A MYOKO',
  'A ROKU',
  'ACACIA REI',
  'ACACIA WA',
  'ACX CRYSTAL',
  'ACX MARGUERITE',
  'AEGEAN EXPRESS',
  'AISOPOS II',
  'ALLEGORIA',
  'ALS SUMIRE',
  'ALTAVIA',
  'ANKING',
  'APL CHINA',
  'APL COMMODORE',
  'APL DENVER',
  'APL DUKE',
  'APL IOLITE',
  'APL IRIS',
  'APL JAPAN',
  'APL KOREA',
  'APL PHILIPPINES',
  'APL SINGAPORE',
  'APL THAILAND',
  'ARABIAN EXPRESS',
  'ARCA',
  'ARIANA',
  'ARIES',
  'AS CLEMENTINA',
  'AS PAULINE',
  'AS SERAFINA',
  'ASIA EXPRESS',
  'ASIAN ACE',
  'ASIAN STAR',
  'ATHENS GLORY',
  'ATHOS',
  'ATLANTA EXPRESS',
  'ATLANTIC VOYAGER',
  'BAL BOAN',
  'BAL PEACE',
  'BAL STAR',
  'BALTHASAR SCHULTE',
  'BALTIC SOUTH',
  'BAOHANG',
  'BELLA J',
  'BELLATRIX I',
  'BF CARP',
  'BF MAHIA',
  'BF PERCH',
  'BF TROUT',
  'BLUE MOON',
  'BLUE OCEAN',
  'BLUE PEAK',
  'BOHAI STAR',
  'BOMAR BELLINI',
  'BOMAR FULGENT',
  'BOMAR ROSSI',
  'BONAVIA',
  'BONNY STAR',
  'BOSTON EXPRESS',
  'BOTSWANA',
  'BOX CHINA',
  'BOX HONG KONG',
  'BRIGHT',
  'BRIGHTON',
  'BUSAN TRADER',
  'BUXLINK',
  'BUXMOON',
  'CAP ANDREAS',
  'CAP PALMERSTON',
  'CAP PASLEY',
  'CAP PATTON',
  'CAPE MARTIN',
  'CAPE SABLE',
  'CARLOTTA STAR',
  'CARPATHIA',
  'CHASTINE MAERSK',
  'CHATTANOOGA',
  'CHINA STAR',
  'CHUN HAK',
  'CHUN WOO',
  'CITY OF SHANGHAI',
  'CMA CGM ALASKA',
  'CMA CGM ARKANSAS',
  'CMA CGM CHENNAI',
  'CMA CGM HERODOTE',
  'CMA CGM MUMBAI',
  'CMA CGM NIAGARA',
  'CMA CGM OHIO',
  'CMA CGM PUGET',
  'CMA CGM TAGE',
  'CMA CGM TANYA',
  'CMA CGM TARPON',
  'CMA CGM TUTICORIN',
  'CO KOBE',
  'CONFIDENCE',
  'CONSCIENCE',
  'CONSISTENCE',
  'CONTI ANNAPURNA',
  'CONTI CHIVALRY',
  'CONTI CONQUEST',
  'CONTI CONTESSA',
  'CONTI CORDOBA',
  'CONTI CRYSTAL',
  'CONTSHIP DAY',
  'CONTSHIP WIN',
  'CORNELIUS MAERSK',
  'COSCO IZMIR',
  'CROATIA',
  'CTP FORTUNE',
  'CZECH',
  'DA XIN HUA CHUN SHUN',
  'DANIEL K.INOUYE',
  'DIMITRA C',
  'DK IRENE',
  'DOLPHIN STRAIT',
  'DONGJIN CONTINENTAL',
  'DONGJIN FIDES',
  'DONGJIN GENIUS',
  'DONGJIN HAKATA',
  'DONGJIN HOPE',
  'DONGJIN KOBE',
  'DONGJIN NAGOYA',
  'DONGJIN TOKUYAMA',
  'DONGJIN VENUS',
  'DONGJIN YOKOHAMA',
  'DRESDEN EXPRESS',
  'DUBAI STAR',
  'DUESSELDORF EXPRESS',
  'EASLINE LIANYUNGANG',
  'EASLINE QINGDAO',
  'EDITH MAERSK',
  'EMORA',
  'ENSENADA',
  'ETOILE',
  'EVER ABLE',
  'EVER ALLY',
  'EVER APEX',
  'EVER BALMY',
  'EVER BOARD',
  'EVER BRAVE',
  'EVER BREED',
  'EVER CALM',
  'EVER CANDID',
  'EVER CHARM',
  'EVER CHEER',
  'EVER CLEAR',
  'EVER COPE',
  'EVER CORE',
  'EVER DAINTY',
  'EVER DECENT',
  'EVER DELIGHT',
  'EVER DELUXE',
  'EVER DEVOTE',
  'EVER DIADEM',
  'EVER DIAMOND',
  'EVER DYNAMIC',
  'EVER FAITH',
  'EVER LINKING',
  'EVER LOADING',
  'EVER LOVELY',
  'EVER LOYAL',
  'EVER LYRIC',
  'EVER RADIANT',
  'EVER REFINE',
  'EVER RESPECT',
  'EVER REWARD',
  'EVER SAFETY',
  'EVER SALUTE',
  'EVER SUMMIT',
  'EVER SUPERB',
  'EVER UBERTY',
  'EVER UNIFIC',
  'EVER UNION',
  'EVER UNIQUE',
  'EVER UNISON',
  'EVER UNITED',
  'EVER UNITY',
  'EVER URANUS',
  'EVER URSULA',
  'FEDERAL',
  'FEEDER 1',
  'FEEDER 2',
  'FESCO TRADER',
  'FITZ ROY',
  'FREEDOM',
  'GH LEVANT',
  'GH SCIROCCO',
  'GH TRAMONTANE',
  'GLOBAL NUBIRA',
  'GLORY STAR',
  'GOLDEN VOYAGE 1',
  'GREEN ACE',
  'GREEN CELESTE',
  'GREEN DAWN',
  'GREEN WAVE',
  'GSL CHRISTEL ELISABETH',
  'GSL CHRISTEN',
  'GSL ELENI',
  'GSL GRANIA',
  'GSL NINGBO',
  'GSL VALERIE',
  'HAI FENG HAI KOU',
  'HAI FENG LIAN FA',
  'HAI SU 12',
  'HAI SU 5',
  'HAKATA VOYAGER',
  'HAMMONIA BALTICUM',
  'HAMMONIA THRACIUM',
  'HANJIN COLOMBO',
  'HANJIN HAIPHONG',
  'HANJIN KAOHSIUNG',
  'HANJIN LIMA',
  'HANJIN MUNDRA',
  'HANJIN OSAKA',
  'HANJIN PARIS',
  'HANJIN ROME',
  'HANJIN SAN DIEGO',
  'HANJIN VANCOUVER',
  'HANJIN WASHINGTON',
  'HANSA COBURG',
  'HANSA CONSTITUTION',
  'HANSA FALKENBURG',
  'HANSA HOMBURG',
  'HANSA PACIFIC',
  'HANSA RENDSBURG',
  'HANSA STRALSUND',
  'HANSUNG INCHEON',
  'HAO AN',
  'HAPPY STAR',
  'HARBOUR RUBY',
  'HARIS',
  'HE SHENG',
  'HENG YU',
  'HEUNG-A MANILA',
  'HEUNG-A PUSAN',
  'HEUNG-A SARAH',
  'HEUNG-A TOKYO',
  'HF WEALTH',
  'HH JOHANNA',
  'HLL BALTIC',
  'HOECHST EXPRESS',
  'HUA HANG HAN YA 1',
  'HUA HANG HAN YA 2',
  'HUA XIANG 936',
  'HYUNDAI GENERAL',
  'HYUNDAI SATURN',
  'IAL 001',
  'IBN SINA',
  'IGA',
  'IKOMA',
  'IMARI',
  'IRENES ROSE',
  'IRIS MIKO',
  'ISEACO FORTUNE',
  'ISEACO HORIZON',
  'ISEACO WISDOM',
  'IWASHIRO',
  'IZU',
  'IZUMO',
  'J. PIONEER',
  'JI FENG',
  'JI RUN',
  'JI YUAN',
  'JIN DA',
  'JIN DING 97',
  'JIN MAN JIANG',
  'JIN TENG',
  'JOSCO DIANA',
  'JOSCO REAL',
  'JOSCO XINGFU',
  'KALAMATA',
  'KAMALA',
  'KARUGA',
  'KETA',
  'KHARIS VENUS',
  'KIEL EXPRESS',
  'KMTC HAIPHONG',
  'KMTC PENANG',
  'KMTC YOKOHAMA',
  'KOTA LAHIR',
  'KOTA LOCENG',
  'KOTA TAMPAN',
  'KUO CHANG',
  'KUO LUNG',
  'KUO TAI',
  'KUO WEI',
  'KUO YU',
  'KURE',
  'KWANGTUNG',
  'KWEILIN',
  'KYAUK PHYU STAR',
  'KYOWA ROSE',
  'LA TOUR',
  'LESOTHO',
  'LILA LONDON',
  'LIN YUAN',
  'LINDAVIA',
  'LIOBA',
  'LISBOA',
  'LOBIVIA',
  'LONG HE',
  'LT GENOVA',
  'LUNG MUN',
  'MAENAM 1',
  'MAERSK AMAZON',
  'MAERSK BOSTON',
  'MAERSK DARTFORD',
  'MAERSK DAUPHIN',
  'MAERSK DHAKA',
  'MAERSK EDIRNE',
  'MAERSK ELBA',
  'MAERSK EMERALD',
  'MAERSK ENSHI',
  'MAERSK EUREKA',
  'MAERSK GEORGIA',
  'MAERSK HAI PHONG',
  'MAERSK INNOSHIMA',
  'MAERSK KALMAR',
  'MAERSK KARACHI',
  'MAERSK KARLSKRONA',
  'MAERSK KAWASAKI',
  'MAERSK KIMI',
  'MAERSK KLEVEN',
  'MAERSK KOKURA',
  'MAERSK KOTKA',
  'MAERSK LINS',
  'MAERSK MALACCA',
  'MAERSK MYTILINI',
  'MAERSK NARVIK',
  'MAERSK NESNA',
  'MAERSK NEWCASTLE',
  'MAERSK NEWHAVEN',
  'MAERSK NORBERG',
  'MAERSK NUSSFJORD',
  'MAERSK PUELO',
  'MAERSK SANA',
  'MAERSK SARAT',
  'MAERSK SEMARANG',
  'MAERSK SHANGHAI',
  'MAERSK VALENCIA',
  'MAERSK WILMINGTON',
  'MAGNAVIA',
  'MANHATTAN BRIDGE',
  'MANOA',
  'MARE PHOENICIUM',
  'MARE SICULUM',
  'MASOVIA',
  'MCC MEDAN',
  'MCC NINGBO',
  'MCC QINGDAO',
  'MCC TAIPEI',
  'MELINA',
  'MERATUS JAYAGIRI',
  'MERATUS JAYAPURA',
  'MERRY STAR',
  'METHI BHUM',
  'MILLENNIUM BRIGHT',
  'MING ZHOU 22',
  'MING ZHOU 56',
  'MING ZHOU 77',
  'MIRAMARIN',
  'MOL LOIRE',
  'MOL PRESENCE',
  'MOL PROFICIENCY',
  'MOL SATISFACTION',
  'MOL WISDOM',
  'MONTE AZUL',
  'MORNING VISHIP',
  'MOUNT KELLETT',
  'MOZAMBIQUE',
  'MSC ALABAMA',
  'MSC ALIYA',
  'MSC ANNICK',
  'MSC ANTONELLA',
  'MSC CARLA 3',
  'MSC CAROLE',
  'MSC DARDANELLES',
  'MSC DESIREE',
  'MSC EARTH',
  'MSC ELISA',
  'MSC ERMINIA',
  'MSC FAITH',
  'MSC FEDERICA',
  'MSC GAYANE',
  'MSC GINA',
  'MSC ISABELLA',
  'MSC JAPAN',
  'MSC JEWEL',
  'MSC KANOKO',
  'MSC MARGRIT',
  'MSC MARS',
  'MSC MARTINA',
  'MSC MELISSA',
  'MSC MESSINA',
  'MSC MIA',
  'MSC NORA',
  'MSC OLIVER',
  'MSC OSCAR',
  'MSC PALERMO',
  'MSC REBECCA',
  'MSC RITA',
  'MSC ROBERTA',
  'MSC RONIT R',
  'MSC RUBY',
  'MSC SAO PAULO',
  'MSC SARDINIA',
  'MSC SENTOSA',
  'MSC TIPHAINE',
  'MSC VANESSA',
  'MSC VERONIQUE',
  'NAKSKOV MAERSK',
  'NAVIOS MIAMI',
  'NAVIOS UNISON',
  'NEOKASTRO',
  'NICOLAI MAERSK',
  'NOEL',
  'NORDAMSTEL',
  'NORDMAAS',
  'NORDMARSH',
  'NORTHERN GRANDOUR',
  'NORTHERN JAGUAR',
  'NORTHERN JAMBOREE',
  'NORTHERN JULIE',
  'NORTHERN JUSTICE',
  'NORTHERN JUVENILE',
  'NORTHERN VIGOUR',
  'NOVA',
  'NSC KINGSTON',
  'NYK JOANNA',
  'NYK LIBRA',
  'NYK LYRA',
  'NYK THEMIS',
  'NYK WREN',
  'OCEANA',
  'OCEANIA DRAGON',
  'ONE ALTAIR',
  'ONE APUS',
  'ONE AQUILA',
  'ONE BLUE JAY',
  'ONE COLUMBA',
  'ONE CONTRIBUTION',
  'ONE CRANE',
  'ONE CYGNUS',
  'ONE EAGLE',
  'ONE FALCON',
  'ONE GRUS',
  'ONE HANGZHOU BAY',
  'ONE HANOI',
  'ONE HARBOUR',
  'ONE HELSINKI',
  'ONE HENRY HUDSON',
  'ONE HONOLULU',
  'ONE HOUSTON',
  'ONE IBIS',
  'ONE MANHATTAN',
  'ONE ORPHEUS',
  'ONE OWL',
  'ONE STORK',
  'ONE SWAN',
  'ONE THESEUS',
  'OOCL HO CHI MINH CITY',
  'OOCL JAKARTA',
  'OOCL NEW YORK',
  'OOCL SHANGHAI',
  'OPHELIA',
  'ORIENT SPIRIT',
  'ORIENTAL SILVER',
  'ORTOLAN EPSILON',
  'PACE',
  'PACIFIC CONDOR',
  'PACIFIC GENEVA',
  'PACIFIC TRADER',
  'PAN HE',
  'PANCON HARMONY',
  'PANSTAR DREAM',
  'PARIS EXPRESS',
  'PARTNER STAR',
  'PEGASUS PLENTY',
  'PEGASUS UNIX',
  'PHILIPPOS-MICHALIS',
  'PHOEBE',
  'PL GERMANY',
  'PORT ADELAIDE',
  'PORTO',
  'POS TOKYO',
  'POS YOKOHAMA',
  'PRINCESS OF LUCK',
  'PROS HOPE',
  'PU HAI XIANG DA',
  'PUSAN',
  'RANEE',
  'RATANA THIDA',
  'RAVEL',
  'RDO CONCEPTION',
  'RDO ENDEAVOUR',
  'RDO FORTUNE',
  'RENOWN',
  'RHINE MAERSK',
  'RJ PFEIFFER',
  'ROBIN HUNTER',
  'RUN LONG',
  'RUN SHENG',
  'SALLY MAERSK',
  'SAN FERNANDO',
  'SAN GIORGIO',
  'SAN PEDRO',
  'SAN VICENTE',
  'SANSTAR DREAM',
  'SATSUKI',
  'SATTHA BHUM',
  'SCO QINGDAO',
  'SEA LAND CHAMPION',
  'SEA LAND METEOR',
  'SEA LAND RACER',
  'SEA-LAND CHARGER',
  'SEA-LAND COMET',
  'SEA-LAND INTREPID',
  'SEA-LAND LIGHTNING',
  'SEALAND MICHIGAN',
  'SEAMAX WESTPORT',
  'SEASPAN ADONIS',
  'SEASPAN AMAZON',
  'SEASPAN BEAUTY',
  'SEASPAN BELIEF',
  'SEASPAN BELLWETHER',
  'SEASPAN BEYOND',
  'SEASPAN BREEZE',
  'SEASPAN BRIGHTNESS',
  'SEASPAN BRILLIANCE',
  'SEASPAN EMINENCE',
  'SEASPAN FALCON',
  'SEASPAN FRASER',
  'SEASPAN OCEANIA',
  'SEASPAN OSPREY',
  'SEASPAN RAPTOR',
  'SEASPAN VANCOUVER',
  'SEASPAN ZAMBEZI',
  'SELAT MAS',
  'SENTOSA STAR',
  'SEVILLIA',
  'SHASTA',
  'SHUN CHENG',
  'SINE MAERSK',
  'SINGAPORE BRIDGE',
  'SINO BRIDGE',
  'SINOKOR INCHEON',
  'SINOKOR MASAN',
  'SINOKOR ULSAN',
  'SINOKOR VLADIVOSTOK',
  'SINOTRANS KAOHSIUNG',
  'SINOTRANS KEELUNG',
  'SITC CHULAI',
  'SITC DANANG',
  'SITC HAKATA',
  'SITC KAOHSIUNG',
  'SKY DUKE',
  'SKY LOVE',
  'SKY PEACE',
  'SM BUSAN',
  'SM KWANGYANG',
  'SM YANTIAN',
  'SOFIA I',
  'SOFIE MAERSK',
  'SOROE MAERSK',
  'SOUL OF LUCK',
  'SOVEREIGN MAERSK',
  'SPIL CITRA',
  'SPIL KARTIKA',
  'ST NIKOLAOS',
  'STAR OF LUCK',
  'STARLINK HOPE',
  'STELLAR ACE',
  'STRAIT MAS',
  'STRAITS CITY',
  'SU ZHOU HAO',
  'SUN RIGHT',
  'SUN ROAD',
  'SUN ROUND',
  'SUNNY AMAZON',
  'SUNNY CANNA',
  'SUNNY CEDAR',
  'SUNNY IVY',
  'SUNNY LINDEN',
  'SUNNY MAPLE',
  'SUNNY OAK',
  'SUNNY OASIS',
  'SUNNY OLIVE',
  'SUNNY PALM',
  'SUNNY PINE',
  'SUNNY SPRUCE',
  'SUNSHINE BANDAMA',
  'SUSAN MAERSK',
  'SVENDBORG MAERSK',
  'SWAZILAND',
  'SYDNEY TRADER',
  'TAI CANG HE',
  'TAI CANG HU',
  'TAI KING',
  'TAN CANG GLORY',
  'TANG SHAN GANG JI 1',
  'TANG SHAN GANG JI 2',
  'TAO YUAN',
  'TEAL HUNTER',
  'THORSKY',
  'TIAN FU(TIANJIN)',
  'TIAN XIANG HE',
  'TIANPING',
  'TIGER',
  'TOUCAN HUNTER',
  'TR ARAMIS',
  'TR PORTHOS',
  'TRADE HOPE',
  'TRADE WORLDER',
  'TRAWIND ACCORD',
  'TRF PESCARA',
  'TRIESTE TRADER',
  'TRINIDAD TRADER',
  'TS BANGKOK',
  'TS KAOHSIUNG',
  'TS KOBE',
  'TS PUSAN',
  'TS SHENZHEN',
  'TS TOKYO',
  'TS YOKOHAMA',
  'TY GREEN',
  'TY INCHEON',
  'UNI-ACCORD',
  'UNI-ADROIT',
  'UNI-AHEAD',
  'UNI-AMPLE',
  'UNI-ANGEL',
  'UNI-ARISE',
  'UNI-ASPIRE',
  'UNI-CONCERT',
  'UNI-PERFECT',
  'UNISEA',
  'VALENCE',
  'VALIANT',
  'VALOR',
  'VALUE',
  'VANTAGE',
  'VEGA TOPAS',
  'VEGA VENTO',
  'VELA',
  'VICTORY HONOR',
  'VIRANA',
  'VLADIVOSTOK',
  'VOLANS',
  'WAN HAI 161',
  'WAN HAI 162',
  'WAN HAI 163',
  'WAN HAI 165',
  'WAN HAI 202',
  'WAN HAI 203',
  'WAN HAI 205',
  'WAN HAI 206',
  'WAN HAI 207',
  'WAN HAI 212',
  'WAN HAI 213',
  'WAN HAI 215',
  'WAN HAI 216',
  'WAN HAI 221',
  'WAN HAI 222',
  'WAN HAI 223',
  'WAN HAI 225',
  'WAN HAI 232',
  'WAN HAI 281',
  'WAN HAI 285',
  'WAN HAI 321',
  'WAN HAI 325',
  'WAN HAI 511',
  'WAN HAI 512',
  'WES SINA',
  'WESTWOOD CASCADE',
  'WESTWOOD DISCOVERY',
  'WESTWOOD PACIFIC',
  'WILLI',
  'WISDOM GRACE',
  'XIANG REN',
  'XIANG SHUN',
  'XIANG WANG',
  'XIANG XING',
  'XIAO YUN',
  'XIN DA LIAN',
  'XIN HAI HONG',
  'XIN JIAN ZHEN',
  'XIN MING ZHOU 18',
  'XIN TAI PING',
  'X-PRESS ANGLESEY',
  'YAN JING',
  'YANTIAN EXPRESS',
  'YI FA',
  'YI SHENG',
  'YM CAPACITY',
  'YM CELEBRITY',
  'YM CENTENNIAL',
  'YM CERTAINTY',
  'YM CONSTANCY',
  'YM CONTINENT',
  'YM CREDIBILITY',
  'YM INCEPTION',
  'YM INCREMENT',
  'YM MASCULINITY',
  'YM TARGET',
  'YM TRIUMPH',
  'YM TRUTH',
  'YM UBERTY',
  'YM UBIQUITY',
  'YM UNANIMITY',
  'YM UNICORN',
  'YM UNIFORMITY',
  'YM UPSURGENCE',
  'YM UPWARD',
  'YM WELLNESS',
  'YM WELLSPRING',
  'YM WHOLESOME',
  'YM WISDOM',
  'YM WREATH',
  'YONG CAI',
  'YORK',
  'ZAMBIA',
  'ZHONG GU BO HAI',
  'ZHONG GU NAN HAI',
  'ZHONG HE',
  '',
];
